import axios from 'axios';

export interface PayabliStatus {
  connected: boolean;
  defaultPaypointLabel: string | null;
  paypointCount: number;
  connectedSince: string | null;
  feeExpenseAccountId: string | null;
  sandbox: boolean;
}

const base = (companyId: string): string => `/companies/${companyId}`;

export const getPayabliStatus = async (companyId: string): Promise<PayabliStatus> => {
  const { data } = await axios.get<PayabliStatus>(`${base(companyId)}/payabli-status`);
  return data;
};

export const updatePayabliFeeAccount = async (
  companyId: string,
  feeExpenseAccountId: string,
): Promise<PayabliStatus> => {
  const { data } = await axios.put<PayabliStatus>(`${base(companyId)}/payabli-fee-account`, {
    feeExpenseAccountId,
  });
  return data;
};
